


import React from 'react';
import './index.scss';
import ComTitle from '@/components/comTitle';
function Void({
    text
}) {
    return (
        <div className='home-void'>
            <img src='https://img12.360buyimg.com/imagetools/jfs/t1/166455/37/16956/47981/606f0852Ebcee82c0/5d11550eb9dc10e1.png'></img>            
            <div>{text}</div>
        </div>
    )
}

export default React.memo(Void);